import { useMemo } from "react";
// hooks
import { useBlockType } from "../../contexts/BlockTypeContext";
// components
import RichTextEditor from "components/rich-text-editor/RichTextEditor";
// styles
import styles from "./styles.module.scss";
// types
import type { BlockItemWithUploadProps } from "../../types";
import getClasses from "utils/getClasses";
// constants
const PLACEHOLDER = "Paragraph text";

const Paragraph = ({
  value,
  onChange,
  onUpload,
  gptBusy,
}: BlockItemWithUploadProps) => {
  const { isFill, isEdit, disabled } = useBlockType();

  const nextValue = useMemo(() => {
    if (Array.isArray(value)) {
      return value[0] || "";
    }

    return value;
  }, [value]);

  return (
    <RichTextEditor
      onUpload={onUpload}
      className={getClasses(
        styles["paragraph"],
        disabled && styles["paragraph--disabled"],
      )}
      editorClassName={styles["paragraph__editor"]}
      disabled={isEdit || disabled || gptBusy}
      readOnly={!isFill || disabled}
      value={nextValue || ""}
      placeholder={PLACEHOLDER}
      {...(isFill && {
        onChange: (e) => onChange && onChange(e),
      })}
    />
  );
};

export default Paragraph;
